import PDFEmbed from "../../../../src/pages/pricing/pdf-embed-api.md";
import PDFService from "../../../../src/pages/pricing/pdf-services-api.md";
import * as React from 'react';
export default {
  PDFEmbed,
  PDFService,
  React
};